import { Icons } from '@/shared';
import {
  StatItemContainer,
  StatLabel,
  StatValue,
} from './AuditStatItem.styles';

interface AuditStatItemProps {
  label: string;
  color: string;
  stats: string;
}

export const StatItem = ({
  label,
  color,
  stats,
}: AuditStatItemProps) => {
  return (
    <StatItemContainer>
      <StatLabel>
        <Icons name="iconDot" color={color} width={11} height={11} />
        {label}
      </StatLabel>
      <StatValue>{stats}</StatValue>
    </StatItemContainer>
  );
};